import React, { useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';

/**
 * Animated shopping-bag icon: the handle lifts slightly on hover (as if the
 * bag were opening), and the whole glyph does a little bounce whenever
 * `bump` changes (e.g. the cart item count changes).
 */
const CartIcon = ({ size = 20, bump = 0, className = '' }) => {
  const controls = useAnimation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    controls.start({
      rotate: [0, -12, 9, -5, 0],
      scale: [1, 1.12, 0.96, 1.05, 1],
      transition: { duration: 0.5, ease: 'easeInOut' },
    });
  }, [bump, controls]);

  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      animate={controls}
      style={{ originX: 0.5, originY: 0.85 }}
      initial="rest"
      whileHover="hover"
    >
      <motion.path
        d="M8.5 8V6.2a3.5 3.5 0 0 1 7 0V8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        variants={{ rest: { y: 0 }, hover: { y: -1.6 } }}
        transition={{ type: 'spring', stiffness: 380, damping: 14 }}
      />
      <path
        d="M5.8 8h12.4l1 11.2a2.2 2.2 0 0 1-2.2 2.4H7a2.2 2.2 0 0 1-2.2-2.4L5.8 8Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        fill="rgba(169, 118, 47, 0.1)"
      />
    </motion.svg>
  );
};

export default CartIcon;